import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Modal from "bootstrap/js/dist/modal"
import TomSelect from "tom-select"

export default class extends Controller {
  open(event) {
    const url = event.currentTarget.dataset.url
    if (!url) return

    const modalEl = document.getElementById('fixture-edit-modal')
    const modal = Modal.getOrCreateInstance(modalEl)

    $.get(url, (html) => {
      $('#fixture-edit-modal .partial[data-id="fixture-edit-form"]').html(html)
      this.enhanceSelects(modalEl)
      modal.show()
    })
  }

  // Constructed directly here, scoped to exactly the elements just injected -
  // no dependency on the app-wide cocoon/boot-time initializer plumbing,
  // which nothing in this app has ever exercised for AJAX-injected content
  // combined with tom-select fields. Same options as
  // initializers/input_components/tom_select.js.
  enhanceSelects(modalEl) {
    modalEl.querySelectorAll('.tom-select').forEach((el) => {
      if (el.tomselect) return

      new TomSelect(el, {
        plugins: el.multiple ? ['remove_button'] : [],
        placeholder: el.dataset.placeholder || 'Select',
        allowEmptyOption: true,
      })
    })
  }

  // Bound via data-action="modal-form:success@document->fixture-edit#reloadList".
  // The fixtures table is server-rendered, so the simplest way to reflect a
  // saved edit is a full reload rather than patching the DOM in place.
  reloadList(event) {
    if (event.target.id !== 'fixture-edit-modal') return

    window.location.reload()
  }
}
